module.exports = __webpack_public_path__ + "ac7cddad8f0840f21b90ac393e5e784e.png";